<template>
    <div class="app-project-dashboard is--sort-index">
        <div class="page-main__section-header">
            <div class="page-main__section-header-text">
                <slot name="navigation"></slot>
                <h4 class="page-main__section-title">Learning Object Custom Sorting Order</h4>
                <p class="element-instructions">
                    Drag and drop each Learning Object into your preferred order, then select Save. You can also quickly sort by alphabetical, created date, and last modified date using the dropdown option on the Content Page.
                </p>
            </div>
            <button
                class="element-button--primary element-button"
                type="button"
                :disabled="disabled"
                @click="updateSortIndex">
                {{ disabled ? 'Saving...' : 'Save' }}
            </button>
        </div>
        <div class="col-lg-12">
            <Draggable
                v-model="learningObjects"
                handle=".object-handle"
                draggable=".object"
                class="app-project-dashboard__lo-handle"
                :group="{ name: 'objects' }"
                @end="onDragEnd">
                <div v-for="(object, cIndex) in learningObjects"
                    class="app-project-dashboard__lo app-accordion object"
                    :key="`object-${object.id}`">
                    <div class="object-handle app-project-dashboard__lo-header app-accordion__header is--disabled">
                        <svg class="element-icon--draggable element-icon" width="1em" height="1em">
                            <use href="/img/icons.svg#icon-draggable"></use>
                        </svg>
                        <p class="app-project-dashboard__lo-header-index">{{ cIndex + 1 }}</p>
                        <h5 class="app-project-dashboard__lo-header-title app-accordion__title">
                            {{ object.name }}
                        </h5>
                    </div>
                </div>
            </Draggable>
        </div>
        <div class="app-toast is--success alert" role="alert" v-if="message">
            <div class="app-toast__text">
                <p class="app-toast__title">{{ message }}zzzz</p>
            </div>
            <button type="button" class="app-toast__close element-button--icon element-button" data-bs-dismiss="alert" aria-label="Close">
                <svg aria-hidden="true" class="element-icon--x element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-x"></use></svg>
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { VueDraggableNext as Draggable } from 'vue-draggable-next'
export default {
    components: {
        Draggable
    },
    props: {
        project: {
            type: Object
        }
    },
    data () {
        return {
            learningObjects: this.project.learning_objects,
            disabled: false,
            error: false,
            message: null,
        }
    },
    methods: {
        async updateSortIndex() {
            this.disabled = true
            this.error = null
            console.log('Updating sort index...');

            const data = this.learningObjects.map(item => ({
                id: item.id,
                sort_index: item.sort_index,
            }));

            try {
                const result = await axios.post(`/projects/${this.project.id}/learning-order/save`, { learningObjects: data });
                
                if (result.errors) {
                    // catch errors
                    this.error = result.errors?.error || result?.message || 'Error updating order'
                } else {
                    this.message = 'Successfully updated.'
                    setTimeout(() => this.message = false, 3000)
                }
            } catch (error) {
                this.error = 'Error updating order'
            }
            this.disabled = false
        },
        onDragEnd() {
            // Update sort_index locally after drag
            this.learningObjects.forEach((item, index) => {
                item.sort_index = index
            })
        },
    }
}
</script>